//Implementa el mismo valor introducido en todos los formularios.
export function implementaValorEnTodosLosForm(elementToHandle) {

    const listElementNewValue = document.getElementsByName(elementToHandle.name);

    for (const element in listElementNewValue) {
        if (listElementNewValue[element].id != null) {
            const inputContainer = document.getElementById(listElementNewValue[element].id);
            inputContainer.value = elementToHandle.value;
        };
    }

}


// WEBPACK FOOTER //
// ./js/utils/modal/implementaValorEnTodosLosForm.js